import type { Dictionary, Nullish } from '@witmetrics/utils';
import type { LoadedFile } from '@/providers/LoadedFilesProvider';

export const classes = {
  wrapper: 'flex w-full grow overflow-hidden min-h-0',
  sceneWrapper: 'grow flex relative w-full',
  message:
    'place-center size-full text-xl text-taupe-3 absolute top-0 left-0 z-10 backdrop-blur-lg transition-all dark:text-mauve-1',
  scene: 'grow w-full',
  pdfViewer: 'size-full overflow-hidden',
  videoViewer: 'size-full overflow-hidden',
  unsupported: 'flex-col',
  pdfControlsFloatingHeader: 'top-[72px] group-data-[compact]/tile:top-[50px]',
  pdfDocumentFloatingHeader: 'pt-32 group-data-[compact]/tile:pt-28',
};

export function buildLoadedFiles(
  fileId?: number,
  loadedFile?: LoadedFile | Nullish
): Dictionary<LoadedFile> {
  return fileId && loadedFile ? { [fileId]: loadedFile } : {};
}
